const MESSAGE_HISTORY_KEY = 'MessageHistory';
export const getMessageHistory = () => {
  return JSON.parse(localStorage.getItem(MESSAGE_HISTORY_KEY) || '{}');
};
export const saveMessageHistory = (history) => {
  localStorage.setItem(MESSAGE_HISTORY_KEY, JSON.stringify(history));
};
export const getMessagesForTopic = (topic) => {
  const history = getMessageHistory();
  return history[topic] || [];
};
export const saveMessagesForTopic = (topic, messages) => {
  const history = getMessageHistory();
  history[topic] = messages;
  saveMessageHistory(history);
};
export const clearMessageHistory = () => {
  localStorage.removeItem(MESSAGE_HISTORY_KEY);
};
export const deleteMessagesForTopic = (topic) => {
  const history = getMessageHistory();
  if (history[topic]) {
    delete history[topic];
    saveMessageHistory(history);
  }
};
